module.exports = __webpack_public_path__ + "img/facebook-shop.4e4ec443.png";